import api from '../';

class ScoutGameApi {
    static getItems(params) {
        return api.axios.get('/scout/items', { params }).then(({ data }) => data);
    }

    static getThemes() {
        return api.axios.get('/scout/themes').then(({ data }) => data.themes);
    }
}

export default ScoutGameApi;
